import React from 'react';
import { connect } from 'react-redux';
import {postFS} from '../Actions/Finance_actions'
import { useState } from 'react';
import history from '../history'
import { LAUNCH } from '../Components/CBtn'
import CloudDoneOutlinedIcon from '@material-ui/icons/CloudDoneOutlined';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';

 
const BtnCon = ({state, getErro}) => {
 
const [word, setWord] = useState('Continue')

const [icon, setIcon] = useState('')
const [iter, ] = useState(false)
const [disAbl, setDA] = useState(false)

const giveAns = ans => { 
    if(ans) 
    {
        return ans
    } 
    else {return ''}
  } 

const handleDb = async () => {
    setDA(true)
    getErro(iter)
    
    if(window.confirm('Pls ensure your entries are correct before saving \n \n use OK if sure or CANCEL to cross check')) {
        setWord('Saving')
        setIcon(<AutorenewRoundedIcon /> )

      let ans = await postFS(state)
        // console.log(ans)
      if(ans === undefined){
        setDA(false)
        setWord('error')
        setIcon(<ErrorOutlineRoundedIcon style={{color:'red'}} />)
        setTimeout(() => {
          setWord('Continue')
          setIcon('')
            
        }, 3000);
      return  }
      if(ans.error !== undefined) {
            alert(ans.error)
          setDA(false)
          setWord('error')
          setIcon(<ErrorOutlineRoundedIcon style={{color:'red'}} />)
          setTimeout(() => {
            setWord('Continue')
            setIcon('')
              
          }, 3000);
          getErro(giveAns(ans.error ? ans.error : ''))
        }

      setDA(false)
       if(ans.save) {
          setWord('done')
          setIcon(<CloudDoneOutlinedIcon />)

          setTimeout(() => {
              history.push('/quote')
          }, 1500);
      }
      else {
          setDA(false)
          setWord('error')
          setIcon(<ErrorOutlineRoundedIcon color={'red'} />)
          setTimeout(() => {
            setWord('Continue')
            setIcon('')
              
          }, 3000);
        }
    } else {
        setDA(false)
        return ''
    }
    
}

    return ( 
        <>
 <LAUNCH onClick={handleDb} disabled={disAbl}>{icon} {word}  </LAUNCH>
        </>
     );
    }

const mapStateToProps = state => ({
    state: state.Fs
})

 
export default connect(mapStateToProps, null)(BtnCon);